import { isEmpty } from 'lodash'

const WAVEFORM_BAR_COLOR = 'rgb:282636'
const WAVEFORM_BACKGROUND_COLOR = 'transparent'
const WAVEFORM_WIDTH = '700'
const WAVEFORM_HEIGHT = '200'

const cloudinaryCloudName = process.env.REACT_APP_CLOUDINARY_CLOUDNAME

const basePageAssetUrl = 'https://res.cloudinary.com/plickers-static/'
const baseUserAssetUrl = process.env.REACT_APP_ENV === 'production' ?
  'https://media.plickers.com/' : `https://res.cloudinary.com/${cloudinaryCloudName}/`

function collapseMultipleSlashes(str) {
  return str.replace(/(^\w+:\/\/)|\/{2,}/g, (_, protocol) => (protocol || '/'))
}

function getMediaBaseUrl(baseUrl, options = {}) {
  const optionsToUse = { resource: 'image', delivery: 'upload', ...options }
  const resourceAndDelivery = `${optionsToUse.resource}/${optionsToUse.delivery}/`
  return collapseMultipleSlashes(`${baseUrl}${resourceAndDelivery}/`)
}

function composeDeliveryUrl(baseUrl, publicId, options = {}) {
  const transformationString = isEmpty(options.transformations) ? '' : `${options.transformations}/`
  const versionString = options.version ? `${options.version}/` : ''
  const folderPathString = options.folderPath ? `${options.folderPath}/` : ''
  const formatString = options.format ? `.${options.format}` : ''
  return collapseMultipleSlashes(`${getMediaBaseUrl(baseUrl, options)}${transformationString}${versionString}${folderPathString}${publicId}${formatString}`)
}

function getPageAssetsImageUrl(folderPath, publicId, options = {}) {
  const optionsToUse = { format: 'png', ...options }
  return composeDeliveryUrl(basePageAssetUrl, publicId, { ...optionsToUse, folderPath })
}

function getPageAssetsVideoUrl(folderPath, publicId, options = {}) {
  const optionsToUse = { format: 'mp4', resource: 'video', ...options }
  return composeDeliveryUrl(basePageAssetUrl, publicId, { ...optionsToUse, folderPath })
}

function getPageAssetsSoundUrl(folderPath, publicId, options = {}) {
  const optionsToUse = { format: 'mp3', resource: 'video', ...options }
  return composeDeliveryUrl(basePageAssetUrl, publicId, { ...optionsToUse, folderPath })
}

function getGifUrls(publicId, options = {}) {
  return {
    stillUrl: composeDeliveryUrl(basePageAssetUrl, publicId, { ...options, transformations: 'pg_1' }),
    webpUrl: composeDeliveryUrl(basePageAssetUrl, publicId, { ...options, format: 'webp' }),
    gifUrl: composeDeliveryUrl(basePageAssetUrl, publicId, { ...options, format: 'gif' }),
  }
}

function getImageBaseUrl() {
  return getMediaBaseUrl(baseUserAssetUrl)
}

function getImageUrl(publicId, options = {}) {
  return composeDeliveryUrl(baseUserAssetUrl, publicId, options)
}

function conformDeliveryUrl(deliveryUrl) {
  return deliveryUrl
}

function getSoundDeliveryUrl(publicId, start = null, end = null, isClipped = false) {
  const transformations = isClipped ? `so_${start},eo_${end}/` : ''
  return composeDeliveryUrl(baseUserAssetUrl, publicId, { resource: 'video', transformations, format: 'mp3' })
}

function getSoundWaveformUrl(publicId, start = null, end = null, isClipped = false) {
  const clipString = isClipped ? `so_${start},eo_${end}/` : ''
  const transformations = `${clipString}h_${WAVEFORM_HEIGHT},w_${WAVEFORM_WIDTH},fl_waveform,co_${WAVEFORM_BAR_COLOR},b_${WAVEFORM_BACKGROUND_COLOR}/`
  return composeDeliveryUrl(baseUserAssetUrl, publicId, { resource: 'video', transformations, format: 'png' }) // use png for Safari support
}

export {
  getPageAssetsImageUrl,
  getPageAssetsVideoUrl,
  getPageAssetsSoundUrl,
  getImageUrl,
  getSoundDeliveryUrl,
  getSoundWaveformUrl,
  getGifUrls,
  getImageBaseUrl,
  conformDeliveryUrl,
}
